import React from 'react';
import { PropTypes } from 'prop-types';
import InputFieldBaseHOC from '../InputFieldBase';
import HrbTranslate from '../../language/HrbTranslate';
import StrengthOMeter from './StrengthOMeter';

const PasswordInputCtrl = (props) => {
    let { propertyName, value, onBlur, onChange, isDisabled, reqs, contentsVisible, toggleVisibility } = props;
    return (
        <div className="hrb-pw-ctrl-container">
            <div className="hrb-pw-ctrl-inner">
                <input name={propertyName}
                    id='new-password-input'
                    type={contentsVisible ? "text" : "password"}
                    value={value}
                    disabled={isDisabled === true}
                    autoComplete="new-password"
                    onChange={(ev) => { onChange(propertyName, ev.target.value) }}
                    onBlur={() => { onBlur(propertyName) }}
                    onFocus={() => {
                        document.getElementById('new-password-input').value = value
                    }}
                />
                <div className="hrb-pw-ctrl-show" onClick={toggleVisibility}>
                    <HrbTranslate text={contentsVisible ? "profile.password_info.pwf_hide" : "profile.password_info.pwf_show"} />
                </div>
            </div>
            <StrengthOMeter reqs={reqs}/>
        </div>
    );
}

PasswordInputCtrl.propTypes = {
    propertyName: PropTypes.string.isRequired,
    labelKey: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    subtextKey: PropTypes.string,
    errorKey: PropTypes.string,
    isDisabled: PropTypes.bool,
    lang: PropTypes.string.isRequired,
    reqs: PropTypes.shape({
        hasCapital: PropTypes.bool.isRequired
    }),
    contentsVisible: PropTypes.bool.isRequired,
    toggleVisibility: PropTypes.func.isRequired
};


export default InputFieldBaseHOC(PasswordInputCtrl);
